/**
 * Constantes pour les tailles d'images standardisées dans l'application
 * Assure la cohérence visuelle sur toutes les pages
 */

export const IMAGE_SIZES = {
  // Images des plats dans les cartes (grilles, listes)
  DISH_CARD: {
    height: 'h-48', // 192px - Taille standard pour les cartes de plats
    className: 'w-full h-48 object-cover'
  },

  // Images des plats dans les détails (page complète) — remplit toute la hauteur de la colonne (min. 500px, cf. md:min-h-[500px] du conteneur)
  DISH_DETAIL: {
    height: 'h-full',
    className: 'w-full h-full object-cover'
  },

  // Images des plats dans les modals/popups
  DISH_MODAL: {
    height: 'h-64', // 256px - Taille standard pour les modals
    className: 'w-full h-64 object-cover'
  },

  // Images des plats dans le panier (aperçu compact)
  DISH_CART: {
    height: 'h-24', // 96px - Taille compacte pour le panier
    className: 'w-24 h-24 object-cover'
  },

  // Images des plats dans la recherche (résultats)
  DISH_SEARCH: {
    height: 'h-32', // 128px - Taille moyenne pour les résultats de recherche
    className: 'w-full h-32 object-cover'
  },

  // Images des restaurants
  RESTAURANT_CARD: {
    height: 'h-40', // 160px - Taille standard pour les cartes de restaurants
    className: 'w-full h-40 object-cover'
  },

  // Images des restaurants en détail
  RESTAURANT_DETAIL: {
    height: 'h-64', // 256px - Taille pour les détails de restaurants
    className: 'w-full h-64 object-cover'
  }
};

// Classes Tailwind prêtes à l'emploi
export const IMAGE_CLASSES = {
  DISH_CARD: IMAGE_SIZES.DISH_CARD.className,
  DISH_DETAIL: IMAGE_SIZES.DISH_DETAIL.className,
  DISH_MODAL: IMAGE_SIZES.DISH_MODAL.className,
  DISH_CART: IMAGE_SIZES.DISH_CART.className,
  DISH_SEARCH: IMAGE_SIZES.DISH_SEARCH.className,
  RESTAURANT_CARD: IMAGE_SIZES.RESTAURANT_CARD.className,
  RESTAURANT_DETAIL: IMAGE_SIZES.RESTAURANT_DETAIL.className
};

// Fonction utilitaire pour obtenir la classe d'image selon le contexte
export const getImageClass = (context) => {
  return IMAGE_CLASSES[context] || IMAGE_CLASSES.DISH_CARD;
};

// Fonction pour obtenir la hauteur selon le contexte
export const getImageHeight = (context) => {
  return IMAGE_SIZES[context]?.height || IMAGE_SIZES.DISH_CARD.height;
};

export default IMAGE_SIZES;














